import React from 'react';
import PropTypes from 'prop-types';
import SrNavbar from 'client/components/SrNavbar';

const SrPage = ({ navbarProps, children }) => (
  <div className="SrPage">
    <SrNavbar {...navbarProps} />
    <div className="SrPageContent">{children}</div>
  </div>
);

SrPage.propTypes = {
  navbarProps: PropTypes.object,
  children: PropTypes.node.isRequired,
};

SrPage.displayName = 'SrPage';

export default SrPage;
